import cn from "classnames"
import React, { useEffect, useRef, useState } from "react"

import { useWindowScroll } from "~/hooks/useWindowScroll"
import { useWindowSize } from "~/hooks/useWindowSize"

import { useSoundContext } from "../../../SoundProvider/SoundProvider"
import audio_1 from "./assets/audio-1.mp3"
import audio_2 from "./assets/audio-2.mp3"
import audio_3 from "./assets/audio-3.mp3"
import audio_4 from "./assets/audio-4.mp3"
import audio_5 from "./assets/audio-5.mp3"
import audio_6 from "./assets/audio-6.mp3"
import audio_7 from "./assets/audio-7.mp3"
import audio_8 from "./assets/audio-8.mp3"
import audio_9 from "./assets/audio-9.mp3"
import audio_10 from "./assets/audio-10.mp3"
import audio_11 from "./assets/audio-11.mp3"
import audio_12 from "./assets/audio-12.mp3"
import spectr_0 from "./assets/spectr0.svg"
import spectr_1 from "./assets/spectr1.svg"
import styles from "./index.module.css"
const audioItems = [
  audio_9,
  audio_10,
  audio_1,
  audio_2,
  audio_3,
  audio_4,
  audio_5,
  audio_6,
  audio_7,
  audio_8,
  audio_11,
  audio_12,
]
const masks = [
  spectr_0,
  spectr_1,
  spectr_0,
  spectr_1,
  spectr_0,
  spectr_1,
  spectr_0,
  spectr_1,
  spectr_0,
  spectr_1,
  spectr_0,
  spectr_1,
]
const quoteItems = [
  {
    autor: "Неизвестный<br /> автор стихов",
    text: "Башни гвоздь протыкает небо.<br> Много теряет тот, кто здесь не&nbsp;был...",
    work: "которыми были расписаны стены внутри башни.",
  },
  {
    autor: "Ян Гришавин",
    text:
      "Помню, что трафик внутри башни был нормальный такой: спускаешься&nbsp;&mdash; встречаешь тех, кто лезет наверх, и&nbsp;наоборот. Потому негласным правилом было не&nbsp;дай бог даже мелкий камушек с&nbsp;досок вниз случайно столкнуть, не&nbsp;то&nbsp;что скинуть что-то.",
    work: "житель Екатеринбурга",
  },
  {
    autor: "Вячеслав Бутусов",
    text:
      "&mdash;&nbsp;Я&nbsp;думаю, что благоразумный и&nbsp;изобретательный подход всегда полезнее, чем просто взять и&nbsp;снести. Мы&nbsp;же все&nbsp;&mdash; свидетели этой телебашни, сколько мы&nbsp;её&nbsp;помним, она всё время стоит, поэтому ей&nbsp;нужно найти какое-то применение. Иначе любая постройка превращается в&nbsp;хлам, когда там отсутствует человек.",
    work: "музыкант",
  },
  {
    autor: "Эдуард Россель",
    text:
      "&mdash;&nbsp;Там осталось достроить 165&nbsp;м металлоконструкций. Это нужно сделать, покрасить телебашню, смонтировать оборудование. Там можно сделать хороший культурный центр&nbsp;&mdash; новый пункт притяжения для горожан, для молодежи.",
    work: "бывший губернатор Свердловской области",
  },
  {
    autor: "Андрей Раевский",
    text:
      "&mdash;&nbsp;То, что мы&nbsp;сейчас наблюдаем, связанное с&nbsp;готовящимся сносом недостроенной телевизионной башни Екатеринбурга, можно назвать не&nbsp;иначе как акт архитектурного, градостроительного, исторического и&nbsp;социокультурного вандализма.",
    work: "архитектор, профессор УрГАХУ ",
  },
  {
    autor: "Евгений Куйвашев",
    text:
      "&mdash;&nbsp;Нелепо иметь в&nbsp;центре прекрасного современного города частично разрушенную бетонную трубу, окружённую пустырём.",
    work: "губернатор Свердловской области",
  },
  {
    autor: "Андрей Козицын",
    text:
      "&mdash;&nbsp;Из&nbsp;этой трубы в&nbsp;2018 году сделать ничего нельзя было по&nbsp;формальным признакам. Чтобы никто не&nbsp;строил никаких иллюзий! По&nbsp;закону ничего нельзя сделать, кто&nbsp;бы чего там ни&nbsp;рассказывал, у&nbsp;кого&nbsp;бы что там ни&nbsp;болело. Вот и&nbsp;всё.",
    work: "гендиректор УГМК",
  },
  {
    autor: "Сергей Санок",
    text:
      "&mdash;&nbsp;Город потерял возможность создания уникального объекта. Насколько была использована эта возможность или нет,&nbsp;&mdash; уже другой вопрос. Я&nbsp;бы оставил башню практически в&nbsp;неизменном виде, перенёс&nbsp;бы туда фонды музея первого президента&nbsp;&mdash; получился&nbsp;бы самый наглядный памятник перестройке.",
    work: "завкафедрой градостроительства и ландшафтной архитектуры УрГАХУ",
  },
  {
    autor: "Аркадий Чернецкий",
    text:
      "&mdash;&nbsp;Сделать что-то из&nbsp;башни было чрезвычайно сложно. Нужны были огромные средства, чтобы её&nbsp;доделать и&nbsp;содержать, а&nbsp;отдача абсолютно мизерная. Был два-три года назад проект музейного комплекса, но&nbsp;просчитали экономику&nbsp;&mdash; абсолютно ничего не&nbsp;идёт. Можно было только этот момент [cноса] оттянуть, чтобы гибель Помпеи не&nbsp;при нас проходила.",
    work: "бывший глава Екатеринбурга",
  },
  {
    autor: "Екатерина Петрова",
    text:
      "Моя #МояБашня была почти 20&nbsp;лет назад, я&nbsp;мало что помню, но&nbsp;некоторые моменты всё&nbsp;же забыть невозможно. Что сподвигло нас с&nbsp;одноклассницами туда отправиться я&nbsp;не&nbsp;помню, возможно ничего, просто кто-то предложил и&nbsp;поехали. Но&nbsp;поехали мы&nbsp;туда прямиком из&nbsp;школы, задвинув математику. Помню, как не&nbsp;просто было ползти вверх по&nbsp;внутренней арматуре почти час, но&nbsp;это не&nbsp;потому что я&nbsp;была в&nbsp;плохой форме, отнюдь, просто потому что я&nbsp;была на&nbsp;каблуках (не&nbsp;спрашивайте). Когда добралась до&nbsp;верха шустро выскочила на&nbsp;балкон, но&nbsp;тут&nbsp;же прижалась к&nbsp;полу. Ветерочек там оказался довольно сильный и&nbsp;перила доверия не&nbsp;внушали, мало того, башню немного покачивало. В&nbsp;те&nbsp;времена башня особо не&nbsp;охранялась и&nbsp;внутрь попасть было не&nbsp;сложно. Поэтому на&nbsp;башне всегда кто-то был, туда постоянно залазили&nbsp;&mdash; кто снаружи по&nbsp;лестнице, кто внутри по&nbsp;арматуре. В&nbsp;какой-то момент на&nbsp;балконе появился незнакомец с&nbsp;флейтой в&nbsp;чемоданчике. Мы&nbsp;с&nbsp;ним спустились чуть ниже балкона, сели у&nbsp;дыры в&nbsp;стене и&nbsp;незнакомец заиграл мелодию битловской песни естудей. Ну&nbsp;а&nbsp;Башня подыграла ему своей аккустикой. Ох, как&nbsp;же это было незабываемо))) Спасибо тебе, незнакомец.",
    work: "жительница Екатеринбурга",
  },
  {
    autor: "Евгений Катыхин",
    text:
      "Мы&nbsp;когда решили залезть первый раз, взяли с&nbsp;собой пакет разливного &rsquo;жигуля&rsquo; в&nbsp;ближайшем киоске на&nbsp;декабристов-степана разина. Пиво оказалось разбавленным, и&nbsp;мы&nbsp;его радостно скинули вниз.",
    work: "житель Екатеринбурга",
  },
  {
    autor: "Никита Страгис",
    text:
      "Надо было лезть в&nbsp;теплую солнечную погоду и&nbsp;по&nbsp;внешней лестнице. Там, на&nbsp;самом деле, легче, если держать эмоции под контролем, а&nbsp;также отличный вид открывается по&nbsp;мере подъёма, всё дальше и&nbsp;дальше. Самый очковый момент&nbsp;&mdash; перелезть в&nbsp;люк, либо лезть дальше вверх, где нет защитных колец и&nbsp;лестница отклоняется от&nbsp;стены башни так, что лезешь под отрицательным углом. Но, опять&nbsp;же, физически это легко. Забравшись, можно любоваться на&nbsp;город, горы и&nbsp;леса на&nbsp;горизонте. А&nbsp;еще оттуда прикольно смотреть салюты на&nbsp;9е&nbsp;и&nbsp;день города, и&nbsp;орать &laquo;не&nbsp;попали!!!&raquo;",
    work: "житель Екатеринбурга",
  },
]

export const Audio = (props) => {
  const { width } = useWindowSize()
  const mobileWidth = width < 768
  const root = document.documentElement
  const player = useRef(null)
  let interval = useRef(0)
  let [activeAudioIndex, changeAudioIndex] = useState(0)
  let [status, changeStatus] = useState(false)
  const [sound, setSound] = useState(true)
  // Переменная отвечает за управление плеером пользователем
  let userClick = useRef(false)

  const { scrollY } = useWindowScroll()

  // Меняем css переменную ширины полосы прокрутки
  const changeProgress = (value) => {
    root.style.setProperty("--width--audio-progress", value + "%")
  }

  // Переключаемся на активную цитату, сдвигая блок
  const changeQuote = (value) => {
    let event = new CustomEvent("changeQuote", {
      detail: {
        activeIndex: activeAudioIndex,
      },
    })
    document.dispatchEvent(event)

    // Высота контейнера с цитатами
    let quoteListHeight = document.getElementById("quote-list").offsetHeight
    // Высота активного элемента цитаты
    let quoteElHeight = document.getElementById("quote-" + activeAudioIndex).offsetHeight
    let rootTranslate = getComputedStyle(root).getPropertyValue("--translate--quote-list")
    let translateY

    if (activeAudioIndex === 0) {
      translateY = 0
    } else if (activeAudioIndex === quoteItems.length - 1) {
      if (!mobileWidth) {
        translateY = -quoteListHeight + quoteElHeight / 5
      }
    } else if (value === "next") {
      translateY = parseInt(rootTranslate, 10) - quoteElHeight
    } else if (value === "prev" && activeAudioIndex !== 0) {
      if (!mobileWidth) {
        const prevQuoteElHeight = document.getElementById("quote-" + (activeAudioIndex + 1))
          .offsetHeight
        translateY = parseInt(rootTranslate, 10) + prevQuoteElHeight
      }
    }

    root.style.setProperty("--translate--quote-list", translateY + "px")
  }

  // Обновление плеера после переключения трека
  const updateAudio = () => {
    clearInterval(interval.current)
    changeProgress(0)
    changeStatus(false)

    changeAudioIndex(activeAudioIndex)
    player.current.src = audioItems[activeAudioIndex]
    setTimeout(() => {
      player.current.play()
      changeStatus(true)
      // eslint-disable-next-line no-use-before-define
      startProgressAudio()
    }, 300)
  }

  const startProgressAudio = () => {
    interval.current = setInterval(start, 1000)

    function start() {
      if (player.current.currentTime >= player.current.duration) {
        clearInterval(interval.current)
        // eslint-disable-next-line no-use-before-define
        nextAudio()
      } else {
        changeProgress((player.current.currentTime / player.current.duration) * 100)
      }
    }
  }

  // Следующий трек
  const nextAudio = () => {
    if (activeAudioIndex !== quoteItems.length - 1) {
      activeAudioIndex++
    } else {
      activeAudioIndex = 0
    }
    updateAudio()
    changeAudioIndex(activeAudioIndex)
    changeQuote("next")
  }

  // Предыдущий трек
  const prevAudio = () => {
    if (activeAudioIndex !== 0) {
      activeAudioIndex--
    } else {
      activeAudioIndex = quoteItems.length - 1
    }
    updateAudio()
    changeAudioIndex(activeAudioIndex)
    changeQuote("prev")
  }

  const play = () => {
    player.current.play()
    changeStatus(true)
    startProgressAudio()
  }

  const pause = () => {
    player.current.pause()
    changeStatus(false)
    clearInterval(interval.current)
  }

  const onClickPlay = () => {
    userClick.current = true
    if (player.current.paused || player.current.ended) {
      play()
      setSound(true)
    } else {
      pause()
      setSound(false)
    }
  }

  const { playStatus } = useSoundContext()

  useEffect(() => {
    if (playStatus === "PLAYING") {
      player.current.volume = props.volume
    }
    if (playStatus === "PAUSED") {
      player.current.volume = 0
    }
  }, [playStatus])

  useEffect(() => {
    if (props.inView && sound) {
      play()
    }
  }, [props.inView])

  useEffect(() => {
    if (playStatus === "PLAYING") player.current.volume = props.volume
  }, [props.inView && scrollY])

  let mask = `url(${masks[activeAudioIndex]})`

  return (
    <div className={styles.QuoteWrapper} id="audio-player">
      <div className={styles.QuoteSlider} id="quote-slider">
        <ul className={styles.QuoteList} id="quote-list">
          {quoteItems.map((item, index) => (
            <li
              id={"quote-" + index}
              key={"quote-" + index}
              className={activeAudioIndex === index ? "" : styles.QuoteBlur}
              dangerouslySetInnerHTML={{ __html: item.text }}
            >
              {/* {item.text} */}
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.Wrapper}>
        <button type="button" className={styles.Button} onClick={onClickPlay}>
          <svg
            className={cn(styles.Icon, { [styles.IconActive]: !status })}
            xmlns="http://www.w3.org/2000/svg"
            height="20"
            width="18"
          >
            <path
              d="M1.233 20C.38 20 0 19.283 0 18.572V1.428C0 .718.381 0 1.233 0c.276 0 .561.083.85.246l15.112 8.572c.512.29.805.721.805 1.182 0 .46-.293.891-.805 1.181L2.083 19.754a1.725 1.725 0 01-.85.246zm0-19.108c-.283 0-.325.336-.325.536v17.144c0 .2.042.536.325.536a.82.82 0 00.396-.127L16.74 10.41c.22-.125.351-.278.351-.41 0-.13-.13-.283-.351-.408L1.629 1.019a.82.82 0 00-.396-.127z"
              fill="#fff"
            />
          </svg>

          <svg
            className={cn(styles.Icon, { [styles.IconActive]: status })}
            xmlns="http://www.w3.org/2000/svg"
            height="20"
            width="14"
          >
            <g fill="#fff">
              <path d="M2.91 0H1.901C.853 0 0 .853 0 1.902V17.7c0 1.05.853 1.903 1.902 1.903H2.91c1.05 0 1.903-.854 1.903-1.903V1.902C4.812.853 3.958 0 2.909 0zm1.028 17.7a1.03 1.03 0 01-1.029 1.028H1.902a1.03 1.03 0 01-1.028-1.029V1.902A1.03 1.03 0 011.902.874H2.91a1.03 1.03 0 011.029 1.028V17.7zM12.098 0H11.09c-1.05 0-1.903.853-1.903 1.902V17.7c0 1.05.854 1.903 1.903 1.903h1.007c1.049 0 1.902-.854 1.902-1.903V1.902C14 .853 13.147 0 12.098 0zm1.028 17.7a1.03 1.03 0 01-1.028 1.028H11.09a1.03 1.03 0 01-1.029-1.029V1.902A1.03 1.03 0 0111.091.874h1.007a1.03 1.03 0 011.028 1.028z" />
            </g>
          </svg>
        </button>
        <div
          className={styles.Progress}
          style={{
            maskImage: mask,
            WebkitMaskImage: mask,
          }}
        >
          <div className={styles.ProgressActive} />
        </div>
        <audio
          ref={player}
          src={audioItems[activeAudioIndex]}
          volume={props.volume ? props.volume : "0.0"}
        />
      </div>
      <div className={styles.QuoteAutorWrapper}>
        <ul className={styles.QuoteAutorList}>
          {quoteItems.map((item, index) => (
            <li
              key={"quote-" + index}
              className={activeAudioIndex === index ? styles.QuoteAutorActive : ""}
            >
              <div className={styles.QuoteAutor} dangerouslySetInnerHTML={{ __html: item.autor }} />
              <div className={styles.QuoteAutorWork}>{item.work}</div>
            </li>
          ))}
        </ul>
        <div className={styles.SliderControls}>
          <button type="button" className={styles.SliderButton} onClick={() => prevAudio()}>
            <svg width="31" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M31 10.4H1v1h30v-1z" fill="#fff" />
              <path d="M10.9 1L1 10.9l9.9 9.899" stroke="#fff" />
            </svg>
          </button>
          <div className={styles.SliderCount}>
            <b>{activeAudioIndex + 1}</b>/{quoteItems.length}
          </div>
          <button type="button" className={styles.SliderButton} onClick={() => nextAudio()}>
            <svg width="31" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 10.4h30v1H0v-1z" fill="#fff" />
              <path d="M20.1 1l9.9 9.9-9.9 9.899" stroke="#fff" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}
